export default "__VITE_ASSET__Csl7zXNe__"